'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _head2 = require('lodash/head');

var _head3 = _interopRequireDefault(_head2);

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

var _utils = require('../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function accessors(target) {
  target.accessors = (0, _extends3.default)({}, target.accessors, {
    data: function data(_data) {
      return (0, _get3.default)((0, _head3.default)(_data), 'datapoints', []);
    },
    annotation: function annotation(options, datum) {
      return (0, _utils.getFormat)(options.format.datapoint)(datum);
    },
    yRange: function yRange(base, axis) {
      return base.xScale.range();
    },
    radius: function radius(options, datum) {
      return options.serie.scatter.markerRadius;
    }
  });
}
exports.default = accessors;